const styles = {
  root: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    width: 80,
    backgroundColor: "#0E3A2A",
    zIndex: 100,
    px: 1,
    pt: 1.75,
    pb: 2.75,
  },
  topLogo: {
    height: 30,
    mt: 0.5,
    mb: 2.5,
    cursor: "pointer",
  },
  button: {
    display: "flex",
    justifyContent: "center",
    gap: "3px",
    width: 46,
    py: "8px",
    borderRadius: "10px",
    transition: "background-color .15s, color .15s",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.06)",
      color: "#fff",
    },
  },
  active: {
    backgroundColor: "#1A4A38",
    color: "#fff",
  },
  link: {
    textDecoration: "none",
  },
  inactiveText: {
    color: "#C8D4CE",
  },
  iconText: {
    fontSize: 9.5,
    fontWeight: 500,
    letterSpacing: 0.2,
    lineHeight: 1.1,
    color: "inherit",
    textDecoration: "none",
  },
};

export default styles;
